import React, { useState } from "react";
import Benefits from "components/benefits";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronPF } from "sections";
import RizeAd from "sections/Home/RizeAd";
import { InfoItem } from "components/pf";
import "sections/sections.css";
import { ClickableButton } from "components/buttons";
import Eligibility from "components/eligibility";
import { handleOpenPdf } from "utils";
import { ASSETS_BASE_URL } from "constants";
import benefit1 from "assets/images/microsite/benefits/benefit1.png";
import benefit2 from "assets/images/microsite/benefits/benefit2.png";
import benefit3 from "assets/images/microsite/benefits/benefit3.png";
import benefit4 from "assets/images/microsite/benefits/benefit4.png";
import benefit5 from "assets/images/microsite/benefits/benefit5.png";
import benefit6 from "assets/images/microsite/benefits/benefit6.png";
import benefit7 from "assets/images/microsite/benefits/benefit7.png";
import benefitsMobile from "assets/images/microsite/benefits/benefits_mobile.png";
import Calculator, { CalculatorCCSP } from "components/calculator";
import FloatingButton from "components/fab/FloatingButton";
import AccordionSimple from "components/accordion/AccordionSimple";
import { FaqListCCSPSD, FaqListCCSPSDHighIncome } from "constants/faq";

const MicrositeCCSP = () => {
  const [incomeRange, setIncomeRange] = useState("below5k");
  const [ faq, setFaq ] = useState(FaqListCCSPSD);

  const handleIncomeRangeChange = (range) => {
    if(range === "above5k") {
      setFaq(FaqListCCSPSDHighIncome);
    }else{
      setFaq(FaqListCCSPSD);
    }
    setIncomeRange(range);
  };
  const pfEligibility = {
    type: "pfccsp",
    title: "Apply easily",
    highlightedText: "in just\n2 steps",
    documentsTitle: "Required Documents",
    employeeType: "Salaried employees",
    eligibilityTitle: "Eligibility",
    yearsOld: "years old",
    documents: [
      {
        text: "Latest <b>1 month payslip</b>",
        backgroundColor: "#DCE9FF",
      },
      {
        text: "<b>HR Confirmation letter</b>",
        backgroundColor: "#F2F4F7",
      },
    ],
    ageRange: {
      minimum: {
        value: incomeRange === "below5k" ? "25" : "25",
        label: "Minimum Age",
      },
      maximum: {
        value: incomeRange === "below5k" ? "60" : "60",
        label: "Maximum Age",
      },
    },
    income: {
      range:
        incomeRange === "below5k" ? "RM3,500 - RM6,000" : "RM6,001* & above",
      description: "of minimum monthly gross income",
    },
  };

  const pfBenefitsDataBelow5k = [
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Financing rates</span> from as low
          as
        </>
      ),
      content: (
        <h2 id="benefits_below5k" className="benefits-text">
          5.10% p.a.*{" "}
        </h2>
      ),
      delay: "100",
    },
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Financing limit</span> up to
        </>
      ),
      content: (
        <h2 id="benefits_below5k" className="benefits-text">
          RM80,000{" "}
        </h2>
      ),
      delay: "200",
    },
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Financing tenure</span> up to
        </>
      ),
      content: (
        <h2 id="benefits_below5k" className="benefits-text">
          8 years
        </h2>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          {" "}
          <span style={{ color: "#221AFB" }}>Affordable payment</span> terms
        </>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Ease</span> of application
        </>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>No guarantor</span> required
        </>
      ),
      delay: "300",
    },
  ];

  const pfBenefitsDataAbove5k = [
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Financing rates</span> from as low
          as
        </>
      ),
      content: (
        <h2 id="benefits_above5k" className="benefits-text">
          5.10% p.a.*{" "}
        </h2>
      ),
      delay: "100",
    },
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Financing limit</span> up to
        </>
      ),
      content: (
        <h2 id="benefits_above5k" className="benefits-text">
          RM250,000{" "}
        </h2>
      ),
      delay: "200",
    },
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Financing tenure</span> up to
        </>
      ),
      content: (
        <h2 id="benefits_below5k" className="benefits-text">
          10 years{" "}
        </h2>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          {" "}
          <span style={{ color: "#221AFB" }}>Affordable payment</span> terms
        </>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Ease</span> of application
        </>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>No guarantor</span> required
        </>
      ),
      delay: "300",
    },
  ];

  const pfBenefitsConfig = {
    heading: "Benefits",
    tnc: "*Terms & Conditions",
    // faq: "FAQ",
    benefitsData:
      incomeRange === "below5k" ? pfBenefitsDataBelow5k : pfBenefitsDataAbove5k,
    // desktopImages: [
    //   [benefit1, benefit2, benefit3],
    //   [benefit4, benefit5],
    //   [benefit6, benefit7],
    // ], to be used in next release
    desktopImages: `${ASSETS_BASE_URL}assets/images/pf/shahrul.svg`,
    mobileImage: `${ASSETS_BASE_URL}assets/images/pf/shahrul.svg`,
    tncLink: "/tnc",
  };

  return (
    <div>
      <section
        className="section jumbotron"
        data-aos="zoom-out"
        data-aos-delay="200"
        style={{ paddingBottom: "8vh" }}
      >
        <JumbotronPF
          badgeText={
            <span>
              Personal Financing-<i>i</i> Corporate Community Select Programme{" "}
            </span>
          }
          title={`Unlock your<br><span className="jumbotron-subtitle-2">financial potential</span>`}
          subText={
            <span>Exclusive financial perks for participating companies. </span>
          }
          buttonText="Let's connect"
          onIncomeRangeChange={handleIncomeRangeChange}
          calculatorComponent={CalculatorCCSP}
        />
      </section>

      <Benefits {...pfBenefitsConfig} />
      <Eligibility {...pfEligibility} />
      <section className="section about container">
        <div
          className="row align-items-center"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div className="col-md-4 order-lg-1 order-2 img-fluid-pf">
            <img
              src={"https://www.alrajhibank.com.my/assets/images/pf/alia.svg"}
              alt="Rates and charges"
              className="img-fluid-pf"
            />
          </div>
          <div
            className="col-md-8 order-lg-2 order-1"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <div className="pf-rates pb-4">
              <span>Our rates & charges</span>
            </div>
            <div className="row">
              <InfoItem
                header="Takaful"
                subheader="Depends on the financing amount, tenure and age"
              />
              <InfoItem
                header="ARNT Fee (or Agency Fee)"
                subheader="RM1 per transaction"
              />
              <InfoItem
                header="Brokerage Fee"
                subheader="0.0008% of the principal amount of financing/disbursement"
              />
              <InfoItem
                header="Annual Financing Statement Fee"
                subheader="RM5 per request (Ad-hoc)"
              />
              {/* <InfoItem
                header="Redemption Statement Fee"
                subheader="RM10 per request"
              />
              <InfoItem
                header={
                  <span>
                    Lawyer’s fee for PF-<i>i</i>&nbsp;Balance Transfer
                  </span>
                }
                subheader="RM20 upon each approved Balance Transfer"
              /> */}
            </div>
          </div>
        </div>
      </section>
      <section
        className="section about container"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <div className="d-flex forms pt-4 justify-content-center align-text-center">
          <span>Forms & Appendices</span>
        </div>

        <div
          className="link-button-row-pf pt-5 justify-content-center"
          data-aos="fade-left"
          data-aos-delay="200"
        >
          <ClickableButton
            variant="primary"
            text={
              <span>
                Personal Financing-<i>i</i> Application Form
              </span>
            }
            onClick={() =>
              handleOpenPdf(
                `${ASSETS_BASE_URL}assets/pdf/personal-financing/PF_application_form.pdf`
              )
            }
          />
          <ClickableButton
            text="Product Disclosure Sheet"
            onClick={() =>
              handleOpenPdf(
                `${ASSETS_BASE_URL}assets/pdf/personal-financing/PDS-PF(CCSP-SD).pdf`
              )
            }
          />
          <ClickableButton
            text="Appendix 1 - Balance Transfer Program"
            onClick={() =>
              handleOpenPdf(
                `${ASSETS_BASE_URL}assets/pdf/personal-financing/Appendix 1 - Balance Transfer Program.pdf`
              )
            }
          />
          <ClickableButton
            text="Appendix 2 - Deduction Form (English)"
            onClick={() =>
              handleOpenPdf(
                `${ASSETS_BASE_URL}assets/pdf/personal-financing/PF Appendix 2 Deduction Form ENG - Final.pdf`
              )
            }
          />
          <ClickableButton
            text="Appendix 2 - Deduction Form (Bahasa Melayu)"
            onClick={() =>
              handleOpenPdf(
                `${ASSETS_BASE_URL}assets/pdf/personal-financing/PF Appendix 2 Deduction Form BM -Final.pdf`
              )
            }
          />
          <ClickableButton
            text="Appendix 3 - Supplemental Terms (English)"
            onClick={() =>
              handleOpenPdf(
                `${ASSETS_BASE_URL}assets/pdf/personal-financing/PF Appendix 3.pdf`
              )
            }
          />
          <ClickableButton
            text="Appendix 3 - Supplemental Terms (Bahasa Melayu)"
            onClick={() =>
              handleOpenPdf(
                `${ASSETS_BASE_URL}assets/pdf/personal-financing/BM_3 Clean Appendix 3.pdf`
              )
            }
          />
        </div>
      </section>

      {/* <section
        className="section about container"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <div className="d-flex forms mb-5 py-4 justify-content-center align-text-center">
          <span>Frequently Asked Questions</span>
        </div>
        <div className="col-xl-10 mx-auto">
              <AccordionSimple data={faq} />
          </div>
      </section> */}

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4" data-aos="fade-left" data-aos-delay="200">
            <h3 style={{ color: "#000045" }}>Let's connect!  </h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8" data-aos="fade-up" data-aos-delay="200">
            <EnquiryForm />
          </div>
        </div>
      </section>
      {/* <RizeAd /> */}
      <FloatingButton />
    </div>
  );
};

export default MicrositeCCSP;
